import { render, staticRenderFns } from "./setNewPassword.vue?vue&type=template&id=2dfd1e05&scoped=true&style=align-items%3A%20center"
import script from "./setNewPassword.vue?vue&type=script&lang=js"
export * from "./setNewPassword.vue?vue&type=script&lang=js"
import style0 from "./setNewPassword.vue?vue&type=style&index=0&id=2dfd1e05&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd1e05",
  null
  
)

export default component.exports